import styled from 'styled-components';
import { Container } from '../../globalStyles';
import { Link } from 'react-router-dom';

export const Nav = styled.nav`
	background: linear-gradient(135deg, #066a67 0%, #066a67 100%);	
	padding-right: 10px;
	padding-left: 10px;
	height: 60px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 1rem;
	position: absolute;
	top: 0;
	z-index: 50;
	width: 100%;
	transition: background 0.3s ease-in;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.75), 0 4px 16px rgba(0, 0, 0, 0.75);
	
	@media screen and (max-width: 960px) {
		position: fixed;
		background: linear-gradient(135deg, #066a67 0%, #066a67 100%);
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3), 0 2px 8px rgba(0, 0, 0, 0.2);
	}
`;

export const NavbarContainer = styled.div`
	width: 100%;
	margin-right: auto;
	margin-left: auto;
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 60px;
	padding: 0 20px;
	
	@media screen and (max-width: 960px) {
		padding: 0 15px;
		height: 60px;
	}

	@media screen and (max-width: 480px) {
		padding: 0 0px;
		height: 70px;
	}
`;

export const NavLogo = styled(Link)`
	color: #fff;
	justify-self: flex-start;
	cursor: pointer;
	text-decoration: none;
	font-size: 2rem;
	display: flex;
	gap: 10px;
	align-items: center;
	z-index: 50;
`;

export const NavIcon = styled.img`
	margin-right: 1rem;
	width: 3rem;
`;

export const MobileIcon = styled.div`
	display: none;
	z-index: 50;
	@media screen and (max-width: 960px) {
		display: flex;
		align-items: center;
		position: absolute;
		top: 10;
		right: 10px;
		font-size: 1.8rem;
		cursor: pointer;
	}
`;

export const RadixagroTitle = styled.h3`
	padding-top: 8px;
	color: ${props => props.color};
	font-size: 1.2rem;
	
	@media screen and (max-width: 960px) {
		font-size: 1.1rem;
	}

	@media screen and (max-width: 480px) {
		font-size: 1rem;
	}
`;


export const NavMenu = styled.ul`
	display: flex;
	align-items: center;
	list-style: none;
	text-align: center;
	height: 60px;
	margin: 0;
	padding: 0;
	@media screen and (max-width: 960px) {
		flex-direction: column;
		width: 100%;
		height: 100vh;
		position: fixed;
		padding-top: 80px;
		padding-bottom: 80px;
		top: 0;
		left: 0;
		opacity: ${({ show }) => (show ? 1 : 0)};
		visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
		transform: translateY(${({ show }) => (show ? '0' : '-10px')});
		transition: opacity 0.5s ease;
		background-color: #04403e;
		overflow-y: auto;
		overflow-x: hidden;
		align-items: flex-start;
	}
`;

export const NavItem = styled.li`
	height: 60px;
	display: flex;
	align-items: center;
	cursor: pointer;
	margin: 0;
	padding: 0;
	@media screen and (max-width: 960px) {
		width: 100%;
		height: ${props => props.isDropdownItem ? '50px' : '60px'};
		background-color: ${props => props.isDropdownItem ? '#04403e' : 'transparent'};
		border-left: ${props => props.isDropdownItem ? '3px solid #18776a' : 'none'};
		&:hover {
			border: none;
		}
	}
`;

export const NavLinks = styled.span`
	color: ${props => props.color};
	display: flex;
	align-items: center;
	justify-content: center;
	text-decoration: none;
	padding: 0rem 1rem;
	height: 100%;
	width: 100%;
	font-size: 1rem;
	&:hover {
		color: #c8c9d8;
		transition: all 0.3s ease;
	}
	@media screen and (max-width: 960px) {
		color: white;
		text-align: center;
		padding: 1.5rem;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 1.1rem;
		&:hover {
			color: #18776a;
			transition: all 0.3s ease;
		}
	}
	@media screen and (max-width: 480px) {
		padding: 1rem;
		font-size: 0.95rem;
	}
`;

export const NavBtnLink = styled(Link)`
	display: flex;
	justify-content: center;
	align-items: center;
	text-decoration: none;
	padding: 8px 16px;
	height: 100%;
	width: 100%;
	border: none;
	outline: none;
`;

export const DropdownContainer = styled.div`
	position: relative;
	height: 100%;
	display: flex;
	align-items: center;
	
	@media screen and (max-width: 960px) {
		width: 100%;
		flex-direction: column;
		align-items: center;
	}
`;

export const DropdownMenu = styled.div`
	position: absolute;
	top: 100%;
	left: 0;
	background: white;
	border-radius: 8px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
	min-width: 280px;
	z-index: 1000;
	opacity: ${({ show }) => (show ? 1 : 0)};
	visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
	transform: translateY(${({ show }) => (show ? '0' : '-10px')});
	transition: all 0.3s ease;
	border: 1px solid #e0e0e0;
	
	@media screen and (max-width: 960px) {
		position: relative;
		width: 100%;
		margin-top: 1rem;
		background: #04403e;
		border: 1px solid #066a67;
	}
`;

export const DropdownItem = styled.div`
	padding: 12px 20px;
	color: #066a67;
	cursor: pointer;
	transition: all 0.3s ease;
	border-bottom: 1px solid #f0f0f0;
	font-size: 0.9rem;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	text-align: left;
	
	&:last-child {
		border-bottom: none;
		border-radius: 0 0 8px 8px;
	}
	
	&:first-child {
		border-radius: 8px 8px 0 0;
	}
	
	&:hover {
		background: #f8f9fa;
		color: #18776a;
		padding-left: 24px;
	}
	
	@media screen and (max-width: 960px) {
		color: white;
		border-bottom: 1px solid #066a67;
		padding: 12px 20px;
		font-size: 0.95rem;
		
		&:hover {
			background: #066a67;
			color: #18776a;
			padding-left: 24px;
		}
	}
	@media screen and (max-width: 480px) {
		padding: 10px 15px;
		font-size: 0.9rem;
	}
`;

export const LanguageSelectWrapper = styled.div`
	@media screen and (max-width: 960px) {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 1rem 0;
	}
`;